import React from 'react'
import { Link, useLocation } from 'react-router-dom'

import { Icon } from '@driftt/tide-icons'

import { rootPath } from 'utils/paths'

import styles from './styles.module.css'

export interface Navigation {
  link?: string
  title?: string
}

export interface BreadcrumbProps {
  to?: Navigation
  from?: Navigation
}

const FALLBACK_TITLE = 'Feed'

const Breadcrumb: React.FC<BreadcrumbProps> = ({ to, from }) => {
  const location = useLocation()
  return (
    <>
      <Link className={styles.backButton} to={from?.link ?? rootPath}>
        {from?.title ?? FALLBACK_TITLE}
      </Link>
      <Icon name="arrow-1-right" width={5} height={8} className={styles.chevron} />
      <Link className={styles.backButton} to={location.pathname}>
        {to?.title ?? 'Contact activity'}
      </Link>
    </>
  )
}

export default Breadcrumb
